interface Step {
  label: string;
  name: string;
  icon: React.ReactNode; // Add icon property for each step
}

interface ProgressTrackerProps {
  steps: Step[];
  currentStep: string;
}

const ProgressTracker = ({ steps, currentStep }: ProgressTrackerProps) => {
  // Get the index of the currentStep from the steps array
  const currentStepIndex = steps.findIndex(step => step.name === currentStep);

  return (
    <div className='flex items-center justify-between w-full'>
      {steps.map((step, index) => {
        // Determine if the step is completed based on its index
        const isCompleted = currentStepIndex >= index;
        return (
          <div
            key={index}
            className='flex items-center justify-center flex-col mt-5'
          >
            <div
              className={`flex items-center justify-center p-3 rounded-full  ${
                isCompleted
                  ? 'bg-success-50 text-white'
                  : 'bg-gray-30 text-gray-50'
              }`}
            >
              {/* Wrap icon in a div that applies the color via CSS */}
              <div className={`${isCompleted ? '[&>svg]:text-white' : ''}`}>
                {step.icon}
              </div>
            </div>
            <div
              className={`text-xs ml-2 ${
                isCompleted ? 'text-success-50 font-semibold' : 'text-gray-50'
              }`}
            >
              {step.label}
            </div>
            {index < steps.length - 1 && (
              <div
                className={`flex-1 h-1 mx-2 ${
                  isCompleted ? 'bg-success-50' : 'bg-gray-30'
                }`}
              ></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressTracker;
